module.exports = __webpack_public_path__ + "static/media/fazhan3.6b02a9e6.png";